/* eslint-disable @typescript-eslint/indent */
import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class Profile extends ModelPrototype {
  public async count(): Promise<{ data: any }> {
    try {
      return this.withUrl(`networking/user_count`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }

  public async list(
    page: number,
    filters?: { specializations?: number[]; types?: number[]; direction?: number; city?: number[] }
  ): Promise<{ data: any }> {
    try {
      return this.withUrl(`networking/user/list`)
        .setMethod(Method.GET)
        .request({
          page,
          ...(filters
            ? {
                ...(filters.specializations !== undefined
                  ? { specializationList: filters.specializations }
                  : {}),
                ...(filters.types !== undefined ? { typeList: filters.types } : {}),
                ...(filters.direction !== undefined ? { direction: filters.direction } : {}),
                ...(filters.city !== undefined ? { cityId: filters.city } : {}),
              }
            : {}),
        });
    } catch (Exception) {
      throw Exception;
    }
  }
}
